import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=1021461a&lang=pug&"
import script from "./PlanDetail.vue?vue&type=script&lang=ts&"
export * from "./PlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=1021461a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports